/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React from 'react';
// material
import { TextField } from '@insticator/insticator-ui'; // iui-material
// styles
import injectSheet from 'react-jss';
import styles from 'pages/dashboard/commenting/addons/commentscountersection/commentscountlabel/commentscountlabel_styles';



/* ========== ~~~~~~~~~~ ADD-ON COMMENTS COUNTER LABEL ~~~~~~~~~~ ========== */
const CommentsCountLabel = props => {

    const { zeroCommentsLabel, singleCommentLabel, multipleCommentsLabel } = props.data;

    const labelTest = /^(?!\s)[\WA-Za-z0-9'\-\s]{1,64}$/;

    const validateLabel = (e, property) => {
        props.onChange({ 
            property, 
            value: {
                ...props.data[property],
                valid: labelTest.test(e.target.value)
            }
        });
    }

    const handleChange = (property, value) => {
        props.onChange({ 
            property,
            value: {
                ...props.data[property],
                value
            }
        });
    }

    return (
        <div className={`commentscountlabel ${props.classes.commentscountlabel} section`}>
            <div className={`sectioncontent`}>
               <div className={'counterlabelfields fields'}>
                   <div className={'fielditem'}>
                        <label>Zero comments</label>
                        <TextField
                            name={'zeroCommentsLabel'} 
                            type={'text'} 
                            placeholder={'Comments'}
                            value={zeroCommentsLabel.value}
                            valid={zeroCommentsLabel.valid}
                            required={true}
                            handleBlur={e => validateLabel(e, 'zeroCommentsLabel')}
                            handleChange={e => handleChange('zeroCommentsLabel', e.target.value)}
                        />
                   </div>
                   <div className={'fielditem'}>
                        <label>One comment</label>
                        <TextField 
                            name={'singleCommentLabel'}
                            type={'text'} 
                            placeholder={'1 Comment'}
                            value={singleCommentLabel.value}
                            valid={singleCommentLabel.valid}
                            required={true}
                            handleBlur={e => validateLabel(e, 'singleCommentLabel')}
                            handleChange={e => handleChange('singleCommentLabel', e.target.value)}
                        />
                   </div>
                   <div className={'fielditem'}>
                        <label>Multiple comments</label>
                        <TextField 
                            name={'multipleCommentsLabel'}
                            type={'text'} 
                            placeholder={'{count} Comments'}
                            value={multipleCommentsLabel.value}
                            valid={multipleCommentsLabel.valid}
                            required={true}
                            handleBlur={e => validateLabel(e, 'multipleCommentsLabel')}
                            handleChange={e => handleChange('multipleCommentsLabel', e.target.value)}
                        />
                   </div>
               </div>
            </div>
        </div>
    )
}

/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default injectSheet(styles)(CommentsCountLabel);